import { AlertTriangle, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

function ImpersonationBanner() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAgencyAdmin } = useAuthStore();

    // Get business_id from URL params
    const urlParams = new URLSearchParams(location.search);
    const impersonatedBusinessId = urlParams.get('business_id');

    // Only show if Platform Owner is impersonating
    const isPlatformOwner = isAgencyAdmin();
    const isImpersonating = isPlatformOwner && !!impersonatedBusinessId;

    if (!isImpersonating) return null;

    const handleExitView = () => {
        // Navigate back to admin dashboard without business_id param
        navigate('/admin');
    };

    return (
        <div style={{
            background: 'linear-gradient(90deg, #F59E0B 0%, #D97706 100%)',
            color: '#1F2937',
            padding: 'var(--spacing-2) var(--spacing-4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--spacing-3)',
            fontSize: 'var(--font-size-sm)',
            fontWeight: 500,
            position: 'sticky',
            top: 0,
            zIndex: 1000
        }}>
            <AlertTriangle size={16} />
            <span>
                You are viewing as <strong>Business #{impersonatedBusinessId}</strong>
            </span>
            <button
                onClick={handleExitView}
                style={{
                    background: 'rgba(0,0,0,0.2)',
                    border: 'none',
                    borderRadius: 'var(--radius-md)',
                    padding: 'var(--spacing-1) var(--spacing-3)',
                    color: '#1F2937',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--spacing-1)',
                    fontWeight: 600,
                    fontSize: 'var(--font-size-xs)'
                }}
            >
                <X size={14} />
                Exit View
            </button>
        </div>
    );
}

export default ImpersonationBanner;
